import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  
  // 1. استرجاع التوكن الأمني بدلاً من بيانات المستخدم كمعيار أساسي
  const [token, setToken] = useState(() => localStorage.getItem('tamkeen_auth_token') || null);

  useEffect(() => {
    // 2. لا يتم تفعيل جلسة المستخدم إلا إذا كان هناك توكن أمني مسجل
    if (token) {
      try {
        const savedSession = localStorage.getItem('tamkeen_user_data');
        if (savedSession) {
          setUser(JSON.parse(savedSession));
        }
      } catch (error) {
        // 3. منع انهيار المنصة إذا تم التلاعب بالبيانات محلياً وتدمير الجلسة فوراً
        console.error("Security/Data corruption detected. Clearing session.");
        logout();
      }
    }
  }, [token]);

  // 4. تعديل دالة الدخول لتستقبل التوكن الأمني (JWT) من الباك-إند مع بيانات المستخدم
  const login = (userData, authToken) => {
    if (!authToken) {
      console.error("Security Alert: Login attempt rejected. Missing Auth Token.");
      return; // نرفض تسجيل الدخول إذا لم يرسل الخادم توكن مشفر
    }
    
    setUser(userData);
    setToken(authToken);
    
    localStorage.setItem('tamkeen_auth_token', authToken);
    localStorage.setItem('tamkeen_user_data', JSON.stringify(userData));
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('tamkeen_auth_token');
    localStorage.removeItem('tamkeen_user_data');
    localStorage.removeItem('tamkeen_live_activity');
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);